import * as yup from 'yup'

const schemaLastUpdate = yup.object().shape({
  title: yup.string().required(),
  subtitle: yup.string().required(),
  tag: yup.string().required(),
  publishedAt: yup.string().nullable(),
  description: yup.string().richTextRequired(),
})

export default schemaLastUpdate
